import moment from 'moment'

import { TimeFormatsLocaleUnsafe } from '@/lib/datetime'

export function getAllTimePeriod() {
	return {
		start_date: moment('2018-01-01').format(TimeFormatsLocaleUnsafe.DateOnly),
		end_date: moment().format(TimeFormatsLocaleUnsafe.DateOnly),
	}
}
